import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Row } from 'react-bootstrap';
import FormBusca from './form_busca';
import ContratoService from '../../../services/contrato'
import Contrato from './contrato';
import Moment from 'moment';
import Botoes from './botoes'


const ListarContratos = () => {

    Moment.locale('pt');
    Moment.updateLocale('pt', {
        months: [
            "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho",
            "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
        ]
    });

    const [contratos, setContratos] = useState([]);
    const [vazio, setVazio] = useState(false);
    const [ano, setAno] = useState("");
    const pathName = window.location.pathname;

    const getTipo = (path) => {
        switch (path) {
            case '/transparencia/contratos/expomacuco/2025':
                setAno("2025");
                return { ano: "2025", service: ContratoService.buscarExpo };
            case '/transparencia/contratos/expomacuco/2024':
                setAno("2024");
                return { ano: "2024", service: ContratoService.buscarExpo };
            case '/transparencia/contratos/expomacuco/2023':
                setAno("2023");
                return { ano: "2023", service: ContratoService.buscarExpo };
            case '/transparencia/contratos/expomacuco/anteriores':
                return { ano: null, service: ContratoService.buscarExpoAnt };
            default:
                return { ano: null, service: null };
        }
    };

    async function fetchContratosIn() {
        const { ano, service } = getTipo(pathName);

        if (!service) {
            setContratos([]);
            setVazio(true);
            return;
        }

        try {
            const response = await service(ano ? { ano: ano } : {});
            if (response.data.length >= 1) {
                setContratos(response.data);
                setVazio(false);
            } else {
                setContratos([]);
                setVazio(true);
            }
        } catch (error) {
            console.error("Erro ao buscar contratos:", error);
            setContratos([]);
            setVazio(true);
        }
    }


    useEffect(() => {
        fetchContratosIn();
    }, [window.location.pathname]);


    return (
        <Fragment>
            <Fragment>
                <FormBusca
                    setContratos={setContratos}
                    setVazio={setVazio}
                    fetchContratosIn={fetchContratosIn}
                    contratos={contratos}
                />
            </Fragment>

            {vazio ? <Fragment>
                <Botoes />

            </Fragment> :
                <Fragment>
                    <Row xs={1}>
                        {contratos.map((contrato, index) =>
                            <Contrato
                                contrato={contrato}
                                key={index}
                            />
                        )}
                    </Row>
                </Fragment>}
        </Fragment>

    )
}

export default ListarContratos;